import { Component, OnInit } from '@angular/core';
import { BaseCommonComponent, UserService, BaseDataService, ModalService, LoaderService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
// import { NotificationsService } from 'angular2-notifications';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-nedeljni-neto-otkupni-fond',
  templateUrl: './nedeljni-neto-otkupni-fond.component.html'
})
export class NedeljniNetoOtkupniFondComponent
  extends BaseCommonComponent
 implements OnInit {

  Config={}
  mainItems=[]
  // _tableColumns=[]
  _ulaz = 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEULAZ1.SINGULAR';
  _izlaz = 'NEDELJNINETOOTKUPNIFOND.IZNOSVALUTEIZLAZ1.SINGULAR';

  baseFormGroup:FormGroup=new FormGroup({
    Datum:new FormControl()
    , ValutaID:new FormControl()
  })

  get fc() { return this.baseFormGroup.controls; }
  submitted: boolean = false;
  ID: number;
 

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected userService: UserService,
    protected baseDataService: BaseDataService,
    protected translateService: TranslateService,
    protected modalService: ModalService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected loaderService: LoaderService
    ) { 
    super(activatedRoute, userService, baseDataService, translateService, modalService,toastrService, loaderService);
  }

 

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Datum", Validators.required, 'required', 'NEDELJNINETOOTKUPNIFOND.DATUM.VALIDATION.REQUIRED');
    this.addValidatorToFc("ValutaID", Validators.required, 'required', 'NEDELJNINETOOTKUPNIFOND.VALUTANAZIV.VALIDATION.REQUIRED');
    //this._tableColumns = this.modelData.MainList.TableColumns;
  }

  OnModelDataLoaded(){
    super.OnModelDataLoaded();
    this.Config={
      EditIcon: {
        Visible: false
      },
      DeleteIcon: {
        Visible: false
      },
      DefaultSortKey: this.modelData.MainList.SortBy,
      DefaultSortReverse: this.modelData.MainList.SortReverse,
      ShowIndex: false,
      ShowDefaultListButtons: false,
      Height: '100w',
      ShowCheckBoxes: false,
      PrintIcon: {
        Visible: false
      }
      ,BreadCrumble: this.modelData.BreadcrumbLabel,
      ColumnBorderEven: false,
      ColumnBorderOdd: true
    }

  }

  
  LoadData(){
    super.LoadData();
    let datumOd = this.baseFormGroup.get("Datum").value;
    let _izracunajDan : Date;
    this.translateService.get([this._izlaz, this._ulaz])
      .subscribe(translate => {
        for(var i = 0; i < 7; i++){
          _izracunajDan = new Date(datumOd["year"], datumOd["month"]-1, datumOd["day"]);
           _izracunajDan.setDate(_izracunajDan.getDate()+i);
            let datum: NgbDate = new NgbDate(_izracunajDan.getFullYear(), _izracunajDan.getMonth()+1, _izracunajDan.getDate());
            for (var j =i+1; j <= i+2; j++){
              // let naziv = this.translateService.get(this.modelData.MainList.TableColumns[i+j].Label)["value"];
              let naziv = (i+j)%2==0 ? translate[this._izlaz] : translate[this._ulaz];
              this.modelData.MainList.TableColumns[i+j].Label = naziv+" "+datum.day+"."+datum.month+"."+datum.year;
            }      
        }
      })

    // this.modelData.MainList.TableColumns = this._tableColumns;
    // for(var i = 0; i < 7; i++){
    //   _izracunajDan = new Date(datumOd["year"], datumOd["month"]-1, datumOd["day"]);
    //    _izracunajDan.setDate(_izracunajDan.getDate()+i);
    //     let datum: NgbDate = new NgbDate(_izracunajDan.getFullYear(), _izracunajDan.getMonth()+1, _izracunajDan.getDate());
    //     for (var j =i+1; j <= i+2; j++){
    //       // let naziv = this.translateService.get(this.modelData.MainList.TableColumns[i+j].Label)["value"];
    //       let naziv = (i+j)%2==0 ? this.translateService.get(this._izlaz)["value"] : this.translateService.get(this._ulaz)["value"];
    //       this.modelData.MainList.TableColumns[i+j].Label = naziv+" "+datum.day+"."+datum.month+"."+datum.year;
    //     }      
    // }
  }

  

}
